export default __webpack_public_path__ + "static/media/twitter1.be95eaa1.svg";